import type { FaireProductEntity } from "../../entity_types/product";

export const p_vesy8kc3v6: FaireProductEntity = {
  token: "p_vesy8kc3v6",
  type: "product",
  name: "Iman Rug - 5x7",
  brandToken: "b_6jjy4txuzi",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/ddb22ec0c77d11c66fcf19246afb4db798b3202d6c4589082bed5dd9389f56ee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4b0aa7ecf1223beb6c31b52919ee31fb07d74804d506ef5d186f217396114ba1.jpeg",
  ],
  priceDollars: 138,
  description:
    "Inspired by vintage Turkish rugs, the heavy washed effect of the Iman Rug lends a relaxed and calming air to soft furnishings. Printed on recycled cotton blend chindi material, the woven texture helps to soften and subdue the patterns and colours making them versatile and easy to style. Spot Clean.",
  tags: [],
  msrpDollars: 276,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:33.601Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
